<template>
  <div>
    <div class="d-flex justify-space-between px-5 pt-5">
      <v-card-title
        v-if="redirection"
        class="px-2 align-self-center secondary--text text-h6 text-md-subtitle-1 font-weight-bold"
      >
        {{ redirection.titre | capitalize }}
      </v-card-title>
      <v-chip
        v-if="isActif"
        class="align-self-center"
        color="secondary"
        outlined
      >
        <div class="texte secondary--text">
          Actif
        </div>
      </v-chip>
      <v-chip
        v-else
        class="align-self-center"
        color="#EC6608"
        outlined
      >
        <div class="texte orange-text">
          Inactif
        </div>
      </v-chip>
    </div>
    <v-chip
      color="var(--kaki)"
      label
      class="ml-6"
    >
      <span
        class="action primary--text"
      >
        {{ redirection.cible.libelle }}
      </span>
    </v-chip>
    <v-row
      class="fixed-height mx-7 mb-4"
      no-gutters
    >
      <v-col
        md="4"
        class="align-self-center texte texte-gris-fonce"
      >
        <v-chip
          v-if="redirection.nouveaute"
          class="align-self-center"
          color="#DBBD00"
          label
          small
        >
          <div class="texte white--text">
            Nouveau
          </div>
        </v-chip>
      </v-col>
      <v-col
        :cols="redirection.nouveaute ? 8 : 12"
        :class="redirection.nouveaute ? 'align-self-center' :''"
        class="texte texte-gris-fonce "
      >
        {{ redirection.texte }}
      </v-col>
    </v-row>
    <v-divider class="mx-5" />
    <div class="d-flex justify-space-around">
      <AgrButton
        icon
        :disabled="isOpenModalAjoutRedirection"
        @click="onDetail"
      >
        <v-icon color="grey darken-2">
          mdi-eye-outline
        </v-icon>
      </AgrButton>
      <AgrButton
        icon
        :disabled="isOpenModalAjoutRedirection"
        @click="onEditRedirection"
      >
        <v-icon color="grey darken-2">
          mdi-pencil-outline
        </v-icon>
      </AgrButton>
      <AgrButton
        icon
        :disabled="isOpenModalAjoutRedirection"
        @click="onDelete"
      >
        <v-icon color="grey darken-2">
          mdi-trash-can-outline
        </v-icon>
      </AgrButton>
    </div>

    <v-dialog
      v-model="dialogLeave"
      persistent
      width="500"
    >
      <ConfirmModal
        cancel-text="Non"
        confirm-text="Oui"
        title="Confirmation"
        @cancel="cancelConfirm"
        @confirm="deleteConfirm"
      >
        <p>Attention, vous souhaitez supprimer le rebond.</p>
        <p>Voulez-vous vraiment continuer ?</p>
      </ConfirmModal>
    </v-dialog>
  </div>
</template>

<script>
import {AgrButton} from '@agrial/ui'
import ConfirmModal from '@/components/modal/confirm-modal.vue'
import {mapActions} from 'vuex'
import { addDays, parse, isWithinInterval, isAfter } from 'date-fns'

export default {
  name: 'CarteRebond',
  components: { AgrButton, ConfirmModal },
  props: {
    redirection: {
      type: Object,
      default: () => { }
    },
    isOpenModalAjoutRedirection : {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogLeave: false
    }
  },
  computed: {
    isActif () {
      if (this.redirection.dateFin != null) {
        return isWithinInterval(new Date(), {
          start: parse(this.redirection.dateDebut, 'yyyy-MM-dd', new Date()),
          end: addDays(parse(this.redirection.dateFin, 'yyyy-MM-dd', new Date()), 1),
        })
      } else {
        return isAfter(new Date(), parse(this.redirection.dateDebut, 'yyyy-MM-dd', new Date()))
      }
    }
  },

  methods: {
    ...mapActions({
      deleteRedirection: 'redirection/deleteRedirection',
    }),

    onDelete () {
      this.dialogLeave = true
    },
    cancelConfirm () {
      this.dialogLeave = false
    },
    deleteConfirm () {
      this.deleteRedirection(this.redirection)
        .catch(() => {
          this.serverError = true
        })
        .finally(() => {
          this.dialogLeave = false
        })
    },
    onEditRedirection () {
      this.$emit('edit', this.redirection)
    },
    onDetail () {
      this.$emit('detail', this.redirection)
    }
  }
}
</script>

<style lang="scss" scoped>
  .background {
    background: var(--gris);
  }
  .height-auto {
    height: 120px;
  }

  .align-end {
    text-align: end;
  }

  .align-center {
    text-align: center;
  }

  .fixed-height {
    height: 70px;
  }

  .orange-text {
    color: #EC6608;
  }

</style>
